export default __webpack_public_path__ + "static/media/step_004.e62334ac.jpeg";